import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { getLandingRoute } from './navigation/app-nav';

// /main no tiene contenido: se envía al usuario a su primera pantalla según sus permisos.
// Solo si no tiene ningún módulo asignado se queda en /main (pantalla en blanco, como antes).
@Injectable({ providedIn: 'root' })
export class LandingGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(): boolean | UrlTree {
    const target = getLandingRoute();
    return target === '/main' ? true : this.router.parseUrl(target);
  }
}
